__turbopack_context__.v({
  "className": "poetsen_one_437aa7cb-module__3_csHG__className",
});
